import { marked } from 'marked';
import DOMPurify from 'dompurify';

const EVIDENCE = /E-[0-9a-f]{12,24}/g;
// "[E-…]", "[E-…, E-…]" or a bare id: citations become numbered chips.
// (No lookbehind: it is not supported by older Safari and would break the bundle.)
const CITATION = /\[\s*E-[0-9a-f]{12,24}(?:\s*[,;]\s*E-[0-9a-f]{12,24})*\s*\]|(^|[^\w-])(E-[0-9a-f]{12,24})(?![\w-])/g;

const purifier = DOMPurify();
purifier.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/** Evidence ids of a text in order of first appearance. */
export function citedIds(text) {
  return [...new Set(String(text || '').match(EVIDENCE) || [])];
}

/**
 * Markdown of an answer as safe HTML. Citations become buttons with data-eid;
 * `numbers` maps evidence ids to their chip numbers (shared with the sources list).
 */
export function renderAnswer(text, numbers = {}) {
  const html = marked.parse(String(text || ''), { breaks: true, gfm: true, headerIds: false, mangle: false });
  const chip = (id) => `<button type="button" class="ai-cite" data-eid="${id}"
    title="Показать доказательство">${numbers[id] || '•'}</button>`;
  const withChips = html.replace(CITATION, (group, prefix, bare) =>
    bare ? `${prefix}${chip(bare)}` : (group.match(EVIDENCE) || []).map(chip).join(''),
  );
  return purifier.sanitize(withChips, {
    ADD_ATTR: ['data-eid', 'target'],
    FORBID_TAGS: ['style', 'form', 'input', 'img', 'iframe'],
  });
}

/** Plain text of a user message with line breaks kept. */
export function renderPlain(text) {
  const escaped = String(text || '').replace(/[&<>]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[ch]));
  return purifier.sanitize(escaped).replace(/\n/g, '<br>');
}
